import { ComponentType } from 'react'
import {
    AccessIcon,
    CircleUserIcon,
    CreditIcon,
    NotificationIcon,
    SupportIcon,
    TransparencyIcon,
} from '../icons'

export interface ISettingItem {
    /** stable name for analytics — never shown */
    key: string
    title: string
    subtext: string
    Icon: ComponentType<{ className?: string }>
    /** the fund id is appended */
    route: string
}

/**
 * The rows of «تنظیمات صندوق», in Android's order
 * (`activity_moneypool_settings.xml`) for the rows both apps have, then the
 * PWA-only ones.
 *
 * «اساسنامه» is not here: Android builds and edits the statute, the PWA never
 * had that screen, and the row it used to show only toasted «در حال پیاده
 * سازی». A row that goes nowhere is worse than no row.
 *
 * Android gives only the notifications row a second line; here every row
 * has one, so the new rows (بانی، پشتیبانی) don't read as a different kind of
 * thing from the old ones.
 */
export const settingItems: ISettingItem[] = [
    {
        key: 'account',
        title: 'مدیریت حساب',
        subtext: 'حساب بانکی و اتصال صندوق به حساب مدیر',
        Icon: CreditIcon,
        route: '/fund/setting/manage/',
    },
    {
        key: 'members',
        title: 'ویرایش اطلاعات اعضا',
        subtext: 'سهم، نقش و وضعیت هر عضو',
        Icon: CircleUserIcon,
        route: '/fund/setting/users-information/',
    },
    {
        key: 'transparency',
        title: 'شفافیت اطلاعات صندوق',
        subtext: 'اعضا وام‌ها، تراکنش‌ها و موجودی صندوق را ببینند یا نه',
        Icon: TransparencyIcon,
        route: '/fund/setting/member-transparency/',
    },
    {
        key: 'notifications',
        title: 'شفافیت ارسال اعلان‌های صندوق',
        subtext: 'پیامک، نوتیفیکیشن و پیام درون‌برنامه‌ای',
        Icon: NotificationIcon,
        route: '/fund/setting/member-sms/',
    },
    {
        key: 'banker',
        title: 'دسترسی بانی',
        subtext: 'بانی چه چیزهایی را ببیند و ثبت کند',
        Icon: AccessIcon,
        route: '/fund/setting/banker-access/',
    },
    {
        key: 'support',
        title: 'پشتیبانی صندوق',
        subtext: 'بله، ایتا و تلفن برای ارتباط اعضا با شما',
        Icon: SupportIcon,
        route: '/fund/setting/support/',
    },
]
